import React, { useEffect, useState } from 'react';
import { Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import AddTeamModal from './AddTeamModal';

function ManagerTeamListPage() {
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showCreateTeamModal, setShowCreateTeamModal] = useState(false);

    const fetchTeams = async () => {
        try {
            setLoading(true);
            const response = await fetch('/api/teams/', {
                withCredentials: true,
            });
            if (response.ok) {
                const data = await response.json();
                setTeams(data.results || data); // Handle both paginated and non-paginated responses
            } else {
                console.error('Failed to fetch teams:', response.status, response.statusText);
                setError('Failed to fetch teams');
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
            setError('Error fetching teams');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTeams();
    }, []);

    if (loading) {
        return (
            <div className="card">
                <div className="card-body">
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const handleTeamAdded = (newTeam) => {
        // hide the modal
        setShowCreateTeamModal(false);

        fetchTeams();

    }

    if (error) {
        return (
            <div className="card">
                <div className="card-body">
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="card">
            <div className="card-header border-0 pb-0">
                <h5 className="card-title">Teams</h5>
                <p className="mb-0">View and manage all teams here.</p>
            </div>
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">Existing Teams</h6>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => setShowCreateTeamModal(true)}
                    >
                        Add Team
                    </Button>
                </div>
                <ul className="list-group">
                    {teams.map((team) => (
                        <li
                            key={team.id}
                            className="list-group-item d-flex justify-content-between align-items-center"
                        >
                            <div className="d-flex align-items-center">
                                <div className="me-3" style={{ width: '40px', height: '40px', flexShrink: 0 }}>
                                    <img
                                        src={team.logo || `${process.env.PUBLIC_URL}/images/kb_static/KLOC_circle.svg`}
                                        alt={`${team.name} logo`}
                                        className="img-fluid rounded-circle"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            border: '1px solid #ddd'
                                        }}
                                    />
                                </div>
                                <div>
                                    <strong>
                                        <Link
                                            to={`/league-manager/teams/${team.id}/`}
                                            className="text-decoration-none"
                                        >
                                            {team.name}
                                        </Link>
                                    </strong>
                                    <br />
                                    <small>
                                        {team.league_name ? team.league_name : 'No league assigned'} •
                                        {team.captain_name ? ` Captain: ${team.captain_name}` : ' No captain assigned'}
                                    </small>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div
                                    className="me-2"
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        backgroundColor: team.color,
                                        borderRadius: '50%',
                                        border: '1px solid #ddd'
                                    }}
                                />
                                <span className="badge bg-primary rounded-pill">
                                    {team.total_games} Games
                                </span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            {/* Add Team Modal */}
            <AddTeamModal
                show={showCreateTeamModal}
                handleClose={() => setShowCreateTeamModal(false)}
                onTeamAdded={handleTeamAdded}
            />

        </div>
    );
}

export default ManagerTeamListPage;
